// The DiscoverTastic component serves as a simple wrapper for the DiscoverSection component,
// allowing it to be integrated into a larger page or layout. By using the 'use client' directive,
// it ensures the component is rendered on the client side in Next.js. Its purpose is to present
// the DiscoverSection within the application, providing a dedicated area for users to explore
// various services or products interactively.

'use client';

import DiscoverSection from 'components/commercetools-ui/organisms/content/discover';
import { TasticProps } from 'frontastic/tastics/types';
import React from 'react';
import { Carousel, CarouselTasticData } from 'types/next';
import useLocale from 'helpers/hooks/useLocale';

const DiscoverTastic = ({ data }: TasticProps<CarouselTasticData>) => {
  const { getCurrency } = useLocale();
  const selectedLocale = getCurrency() === 'GBP' ? 'en-GB' : 'en-EU';

  const discoverContent = data?.data?.dataSource?.carousels?.find(
    (content: Carousel) => content?.contentID === data?.contentID,
  ) as Carousel;

  // Only render if isShow for the current locale is true
  if (!discoverContent?.isShow?.[selectedLocale]) {
    return null;
  }

  return (
    <>
      <DiscoverSection content={discoverContent} />
    </>
  );
};

export default DiscoverTastic;
